// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bax_a"};